import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SimpleGrid,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useState } from "react";
import { GoLinkExternal } from "react-icons/go";
import { MdDeleteOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomModal from "../../../Components/Common/CustomModal/CustomModal";
import AddNewCaseForm from "../CaseView/AddNewCaseForm";
import EdssSearch from "../CaseView/EdssSearch";

const LinksBox = ({ data, caseId }) => {
  const [linkedCases, setLinkedCases] = useState(data);

  const { onOpen, isOpen, onClose } = useDisclosure();
  const {
    onOpen: onNewCaseOpen,
    isOpen: isNewCaseOpen,
    onClose: onNewCaseClose,
  } = useDisclosure();
  const navigate = useNavigate();

  const handleNavigation = (caseItem) => {
    localStorage.setItem("recentClickCase", JSON.stringify(caseItem));
    navigate(`/CaseView/${caseItem?.id}/${caseItem?.PERSON_ID}`);
  };

  const handleDelete = async (item) => {
    try {
      const response = await fetch(
        `/api/deletelink?id=${caseId}&lid=${item.lid}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          errorText || `Server responded with status ${response.status}`
        );
      }

      // Successfully deleted from backend
      setLinkedCases((prevCases) => {
        // Filter out the deleted item by its `lid`
        const updatedCases = prevCases.filter((i) => i.lid !== item.lid);
        console.log("Updated cases:", updatedCases); // For debugging
        return updatedCases;
      });

      toast.success("Successfully deleted");
    } catch (error) {
      console.error("Error deleting link:", error);
      toast.error(`Delete failed: ${error.message}`);
    }
  };

  return (
    <Box>
      <SimpleGrid spacing={4} columns={{ base: 1, md: 4 }}>
        {linkedCases?.map((caseinfo, idx) => {
          const { EVENT_DATE, FIRST_NAME, LAST_NAME, LINK_TYPE, PRODUCT } =
            caseinfo;
          return (
            <Box
              key={caseinfo.lid || idx}
              borderWidth="1px"
              borderRadius="lg"
              p={2}
              boxShadow="md"
              _hover={{
                transform: "scale(1.05)",
                boxShadow: "lg",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <Flex alignItems="center" justifyContent="space-between" mb={2}>
                <GoLinkExternal
                  fontSize="16px"
                  color="black"
                  cursor="pointer"
                  onClick={() => handleNavigation(caseinfo)}
                />
                <MdDeleteOutline
                  fontSize="16px"
                  color="red"
                  cursor="pointer"
                  onClick={() => handleDelete(caseinfo)}
                />
              </Flex>

              <InfoRow label="Name" value={`${FIRST_NAME} ${LAST_NAME}`} />
              <InfoRow label="Product" value={PRODUCT} />
              <InfoRow label="Link Type" value={LINK_TYPE} />
              <InfoRow
                label="Event Date"
                value={moment(EVENT_DATE, "YYYYMMDD").format("MM/DD/YYYY")}
              />
            </Box>
          );
        })}

        <Box
          borderWidth="1px"
          borderRadius="lg"
          p={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Menu>
            <MenuButton
              px={4}
              py={2}
              transition="all 0.2s"
              borderRadius="md"
              borderWidth="1px"
              _expanded={{ bg: "gray.100" }}
              _focus={{ boxShadow: "outline" }}
            >
              Add New <ChevronDownIcon />
            </MenuButton>
            <MenuList>
              <MenuItem onClick={() => onNewCaseOpen()}>Create New</MenuItem>
              <MenuItem onClick={() => onOpen()}>Link to</MenuItem>
            </MenuList>
          </Menu>
        </Box>
      </SimpleGrid>

      <CustomModal
        size="6xl"
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        bodyContent={<EdssSearch onClose={onClose} />}
      />
      <CustomModal
        size="6xl"
        isCentered
        title="Add new case and link"
        isOpen={isNewCaseOpen}
        onClose={onNewCaseClose}
        bodyContent={<AddNewCaseForm />}
      />
    </Box>
  );
};

// ✅ Optional small helper component to clean up the repeated row structure
const InfoRow = ({ label, value }) => (
  <Flex alignItems="center" justifyContent="space-evenly" fontSize="sm">
    <Box textAlign="left" w="40%">
      {label}
    </Box>
    <Box textAlign="center"> : </Box>
    <Box textAlign="left" width="60%" ml={4}>
      <Text>{value}</Text>
    </Box>
  </Flex>
);

export default LinksBox;
